import { Box, Typography } from "@mui/material";

const InfoRowHeader = ({ label, value }) => {
  return (
    <Box sx={{ mb: 1.5 }}>
      <Typography
        sx={{
          fontSize: "0.75rem",
          fontWeight: 700,
          color: "text.secondary",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
          lineHeight: 1.1,
        }}
      >
        {label}
      </Typography>

      <Typography
        sx={{
          fontSize: "0.875rem",
          fontWeight: 700,
          color: "text.primary",
          lineHeight: 1.2,
          mt: 0.2,
        }}
      >
        {value || "-"}
      </Typography>
    </Box>
  );
};

export default InfoRowHeader;